import { render, staticRenderFns } from "./ApplicationTerms.vue?vue&type=template&id=22e61ce0&"
import script from "./ApplicationTerms.vue?vue&type=script&lang=js&"
export * from "./ApplicationTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports